document.addEventListener('DOMContentLoaded', function () {
  var botones = document.querySelectorAll('.spp-orden-boton');

  botones.forEach(function (boton) {
    boton.addEventListener('click', function () {
      var valor = boton.getAttribute('data-spp-orden-valor');
      var grupo = boton.closest('.spp-orden-botones');
      var select = document.getElementById('SortBy-mobile');
      if (!select) return;

      grupo.querySelectorAll('.spp-orden-boton').forEach(function (otro) {
        otro.classList.remove('spp-orden-boton--activo');
      });
      boton.classList.add('spp-orden-boton--activo');

      select.value = valor;
      select.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
});

document.addEventListener(
  'click',
  function (evento) {
    var resumen = evento.target.closest('.mobile-facets__details.js-filter:not(.spp-orden-envoltura) > summary');
    if (!resumen) return;
    var detalle = resumen.parentElement;
    if (!detalle.hasAttribute('open')) return;
    evento.preventDefault();
    evento.stopImmediatePropagation();
    detalle.removeAttribute('open');
    detalle.classList.remove('menu-opening');
    resumen.setAttribute('aria-expanded', 'false');
    var padre = detalle.closest('.submenu-open');
    if (padre && !padre.querySelector('.mobile-facets__details.js-filter[open]')) {
      padre.classList.remove('submenu-open');
    }
  },
  true
);
